import React from 'react';

import MapBlock from 'components/shared/MapBlock';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';

import styles from './index.module.css';

function Map(props) {
  const { coords, name, address } = props;

  return (
    <>
      <FormTitle center>{`${name}: Map`}</FormTitle>
      <MapBlock containerStyle={{ width: '100%', height: '28rem' }} coords={coords} />
      <div className={styles.address}>
        <Text accent isStrong>
          Address:
        </Text>{' '}
        <Text accent>{address}</Text>
      </div>
    </>
  );
}

export default Map;
